import { render } from "./TopNav.vue?vue&type=template&id=16754b68"
import script from "./TopNav.vue?vue&type=script&lang=ts"
export * from "./TopNav.vue?vue&type=script&lang=ts"
script.render = render

export default script